import { FC, memo, useMemo } from 'react'

import { Document } from 'commons/types/DTO/bank/companyDetails/document'
import { DocumentSubjectType, TableDataQa } from 'commons/types/enums'
import { DataSourceItem, Layer, Table } from 'ui/components'
import { Button } from 'ui/components/Buttons'
import { Link } from 'ui/components/Link'
import { PageSection } from 'ui/components/Page'

import { BankAccountDocumentsProps } from './BankAccountDocuments.types'
import { columns } from './columns'
import { Filter } from './components'
import { useComponentsEssence } from './hooks/useComponentsEssence'

export const BankAccountDocuments: FC<BankAccountDocumentsProps> = memo((props) => {
  const { data, documentEditCancelReturnUrl, onFilterBankAccountDetails } = props
  const { items: documents, total } = data.documents
  const { id: bankAccountId } = data

  const {
    loading,
    tableState,
    filterForm,
    changePagination,
    onSort,
    DeleteConfirmation,
    onDeleteDocument,
    clearFilter
  } = useComponentsEssence(onFilterBankAccountDetails, data)

  const mappedDocuments: DataSourceItem<any>[] = useMemo(
    () =>
      documents.map((el) => ({
        item: el
      })),
    [documents]
  )

  const memoizedColumns = useMemo(() => columns(onDeleteDocument, documentEditCancelReturnUrl), [])

  return (
    <PageSection
      title="Documents"
      anchor="documents"
      actions={
        <Link
          to="/documents/new"
          search={{
            subjectType: DocumentSubjectType.BANK_ACCOUNT,
            bankAccountId: bankAccountId,
            subjectName: data.number,
            returnUrl: documentEditCancelReturnUrl
          }}
        >
          <Button face="tertiary">Add New</Button>
        </Link>
      }
    >
      <DeleteConfirmation />
      <Layer rounded shadowed stretch>
        <Filter
          form={filterForm}
          expanded={tableState.expanded}
          onToggle={tableState.onFilterToggle}
          webPage={data}
          onClear={clearFilter}
        />
        <Table<Document>
          dataQa={TableDataQa.BP_BANK_ACCOUNT_DOCUMENTS}
          columns={memoizedColumns}
          dataSource={mappedDocuments}
          loading={loading}
          pagination={{
            page: tableState.page,
            size: tableState.size,
            onChange: changePagination,
            total
          }}
          sorting={{ order: tableState.order || [], onChange: (value) => onSort(value.direction, value.field) }}
        />
      </Layer>
    </PageSection>
  )
})
